import api, { request } from '../../../api';
import { IErrorsStore } from '../../errors/store';
import { IActionGroup, IStore } from '../../index';
import { ISource, IStripeToken } from '../../user/store';
import { IRoundPaymentsStore } from './store';

export interface IRoundPaymentsActions extends IActionGroup {
  launch: (
    clubId: number,
    eventId: number,
    roundId: number,
    payment: IStripeToken | ISource,
    couponCode?: string
  ) => { roundPayments?: IRoundPaymentsStore; errors?: IErrorsStore };
  get: (
    clubId: number,
    eventId: number,
    roundId: number,
    couponCode?: string
  ) => { roundPayments?: IRoundPaymentsStore; errors?: IErrorsStore };
}

const actions: IActionGroup = {
  launch: async (
    state: IStore,
    clubId: number,
    eventId: number,
    roundId: number,
    payment: IStripeToken | ISource,
    couponCode?: string
  ) => {
    const data = !!payment
      ? (payment as ISource).djstripeId
        ? { club: clubId, credit_card: (payment as ISource).djstripeId }
        : { club: clubId, token: (payment as IStripeToken).id }
      : { club: clubId };
    const response = await request.post(
      `${api.admin.eventRounds(clubId, eventId, roundId)}launch/`,
      {
        ...data,
        ...(couponCode ? { coupon: couponCode } : {})
      }
    );

    if (response.error) {
      return {
        errors: {
          adminRoundPayments: {
            msg: response.error.statusText || 'Unknown error'
          }
        }
      };
    }
    return {
      state
    };
  },

  get: async (_: IStore, clubId: number, eventId: number, roundId: number, couponCode?: string) => {
    const response = await request.post(
      `${api.admin.eventRounds(clubId, eventId, roundId)}summary/`,
      couponCode ? { coupon: couponCode } : {}
    );

    if (response.error) {
      return {
        errors: {
          adminRoundPayments: {
            msg: 'Error fetching the Round Payments',
            ...response.error
          }
        }
      };
    }
    return {
      adminRoundPayments: {
        [roundId]: response
      }
    };
  }
};

export default actions;
